// «Ver e imprimir» del Formato Amarillo, el mismo en la lista de versiones y en la carta de cada
// autoridad (HU-19-C4, CC2-19-C1; BUG-1090, `ui/MG-ILE-1090.md`).
//
// Es el `Button` secundario del catálogo y no un enlace: el documento se pide por el cliente,
// con el token, y se abre en otra pestaña con `abrirDocumentoEnPestana`. Un enlace a la API
// salía sin `Authorization` y con el inicio de sesión de Microsoft mostraba el 401.

import { Printer } from 'lucide-react';
import { Button } from './ui';

/**
 * Mientras descarga queda deshabilitado (un segundo clic no abre otra pestaña), marca
 * `aria-busy` y dice «Abriendo…» en una región de estado, para que el lector de pantalla lo
 * anuncie: `<output>`, que lleva el rol `status` implícito (Sonar S6819 prefiere la etiqueta al
 * rol). Los `data-*` (testid, autoridad, versión) pasan tal cual al botón.
 */
export default function BotonVerEImprimir({ ocupado, texto, onImprimir, className, ...atributos }: Readonly<{
  ocupado: boolean;
  texto: string;
  onImprimir: () => void;
  className?: string;
  'aria-label'?: string;
}>) {
  return (
    <Button variant="secondary" size="sm" icon={Printer} className={className} onClick={onImprimir}
      disabled={ocupado} aria-busy={ocupado} {...atributos}>
      {ocupado ? <output>Abriendo…</output> : texto}
    </Button>
  );
}
